import { Route, Routes } from 'react-router-dom'
import { AuthorizeUser } from '../components/Pages/AuthorizeUser.Page'
import { BrandDetail } from '../components/Pages/BrandDetail.Page'
import { ShowMigrateduserDetails } from '../components/Pages/ShowMigrateduserDetails.Page'
import { TabsPages } from '../components/ComponentNodes/FormTabs/TabsPages.Page'
import { ForgotPasswordEnterCode } from '../components/Pages/ForgotPasswordEnterCode.Page'
import { ResetOldPassword } from '../components/Pages/ResetOldPassword.Page'


export const HomeRouter = () => {
  return (
    <Routes>
      <Route path="/" element={<AuthorizeUser />} />
      <Route path="/:emailId" element={<AuthorizeUser />} />  
      <Route exact path='/show-user-details/:emiratesID' element={<TabsPages />} />
      <Route exact path='/brand-detail/:brandId' element={<BrandDetail />} />
      <Route path='/forgot-password/entercode' element={<ForgotPasswordEnterCode/>}/>

    </Routes>
  )
}
